import React, { useEffect, useState } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import loadable from 'loadable-components';

import history from './history';
import Layout from './components/molecules/Layout';
import theme from './theme';

const Home = loadable(() => import('./pages/Home'));
const LandList = loadable(() => import('./pages/LandList'));
const CouponList = loadable(() => import('./pages/CouponList'));
const Coupon = loadable(() => import('./pages/Coupon'));
const RedirectToMme = loadable(() => import('./pages/RedirectToMme'));

const App = () => {
  const [member, setMember] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (window) {
      window.extAsyncInit = () => {
        setReady(true);
      };
      setTimeout(() => {
        getMember();
      }, 500);
    }
  }, []);

  const getMember = () => {
    if (window && window.MessengerExtensions) {
      window.MessengerExtensions.getSupportedFeatures(
        result => {
          let features = result.supported_features;
          if (features.indexOf('context') < 0) {
            alert('Sorry, please make sure your Messenger updated');
            setTimeout(() => {
              window.MessengerExtensions.requestCloseBrowser(
                function success() {
                  // webview closed
                },
                function error(err) {
                  // an error occurred
                  console.log('err', err);
                }
              );
            }, 5000);
          } else {
            window.MessengerExtensions.getContext(
              '2087214101500691',
              async thread_context => {
                const result = await fetch(
                  `https://ryc3gerrz6.execute-api.ap-east-1.amazonaws.com/prod/webhook`,
                  {
                    method: 'POST',
                    headers: {
                      'content-type': 'application/json',
                    },
                    body: JSON.stringify({
                      thread_context,
                    }),
                  }
                ).then(res => res.json());
                console.log('result', result);
                if (result.ok) {
                  setMember(result.member);
                  setLoading(false);
                }
              },
              err => {
                console.log('err', err);
              }
            );
          }
        },
        function error(err) {
          setLoading(false);
          console.log(err);
        }
      );
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Router history={history}>
        <Layout member={member} loading={loading}>
          <Switch>
            <Route path="/" render={props => <Home {...props} />} exact />
            <Route
              path="/coupon/:id"
              render={props => <Coupon {...props} getMember={getMember} />}
              exact
            />
            <Route exact path="/lands" render={props => <LandList {...props} member={member} />} />
            <Route
              exact
              path="/coupons"
              render={props => <CouponList {...props} member={member} />}
            />
            <Route exact path="/redirectToMme" render={props => <RedirectToMme {...props} />} />
            <Route render={props => <Home {...props} />} />
          </Switch>
        </Layout>
      </Router>
    </ThemeProvider>
  );
};

export default App;
